
import Tasks from "../components/tasks/Tasks"


const TasksPage = () => {
    return <>
        <Tasks />
    </>
}

export default TasksPage
